import React from 'react'
import { CircularButtonProgress } from './ButtonProgress.styles'

const ButtonProgress = (props) => <CircularButtonProgress {...props} />
export default ButtonProgress
